import React, { useState } from 'react';
import { tid } from '@utils/test';
import { TABLE_HEIGHT_MAPPING } from '@components/dimension-panel-hz/header/Resize';
import {
  DimensionTableWrapper,
  DimensionTitle,
} from '@components/dimension-panel-hz/dimension-table/styled';
import AppDimensionTable, {
  type AppDimensionTableProps,
} from '@components/dimension-panel-hz/dimension-table/AppDimensionTable';

export interface StaticTableWidgetProps extends Omit<AppDimensionTableProps, 'updateGrid'> {
  header: string;
}

const StaticTableWidget = (props: StaticTableWidgetProps) => {
  const { header, dimension, ...rest } = props;
  const [gridRow, updateGrid] = useState(TABLE_HEIGHT_MAPPING.s);
  const dndStyle = {
    gridRow: `span ${gridRow}`,
  };

  return (
    <DimensionTableWrapper
      id={dimension}
      style={dndStyle}
      {...tid(`dimension-table::${dimension}`)}
    >
      <DimensionTitle>{header}</DimensionTitle>
      <AppDimensionTable {...rest} dimension={dimension} updateGrid={updateGrid} />
    </DimensionTableWrapper>
  );
};

export default StaticTableWidget;
